import { FileOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";

import ManualLinkProps from "./props";

const ManualLink: React.FC<ManualLinkProps> = ({ fileName }) => (
  <Button
    type="link"
    icon={<FileOutlined />}
    href={`/manuals/${fileName}`}
    target="_blank"
  >
    Manual
  </Button>
);

export default ManualLink;
